/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
export default function isNumeric(n) {
    return (n !== '' && !isNaN(parseFloat(n)) && isFinite(n));
}
